import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, withProps, branch } from 'recompose';
import { connect } from 'react-redux';
import { List } from 'immutable';

import { withFetch } from '../../../app/entities/Entity/containers';
import { withTimeplanUnits } from '../../../app/containers';
import requireProps from '../../../app/lib/requireProps';
import { bookingById } from '../../../app/entities/Booking/selectors';
import withWorkTypes from '../../../app/containers/withWorkTypes';
import CustomerSummary from './components/CustomerSummary';
import Form from './components/Form';
import Details from './components/Details';
import * as styles from './styles.css';
import { useTranslation } from 'react-i18next';

function ReportedTimes({ customersIds, timeplanUnits, workTypes, fetchReportedPeriods, isEmpty }) {
  const { t } = useTranslation();
  return (
    <div className="row">
      <div className="col-md-4">
        <h2 className={styles.header}>{t("Rapporterade tider")}</h2>
        <Form fetchReportedPeriods={fetchReportedPeriods} />
      </div>
      <div className="col-md-4">
        {isEmpty && (
          <p className="alert alert-info">{t("Det finns inga tider rapporterade under vald period.")}</p>
        )}
        {customersIds.length > 0 && (<b>{t("Summering")}</b>)}
        {customersIds.map(id => (
          <CustomerSummary
            key={id}
            customerId={id}
            workTypes={workTypes}
            timeplanUnits={timeplanUnits}
            bookedPeriods={timeplanUnits}
          />
        ))}
      </div>
      <div className="col-md-4">
        <Details timeplanUnits={timeplanUnits} />
      </div>
    </div>
  );
}

ReportedTimes.defaultProps = {
  customersIds: [],
  timeplanUnits: new List(),
  workTypes: new List(),
  isEmpty: false,
};

ReportedTimes.propTypes = {
  customersIds: PropTypes.arrayOf(PropTypes.string),
  timeplanUnits: PropTypes.instanceOf(List),
  workTypes: PropTypes.instanceOf(List),
  fetchReportedPeriods: PropTypes.func.isRequired,
  isEmpty: PropTypes.bool,
};

export default compose(
  withFetch(),
  lifecycle({
    componentWillMount() {
      const fetchReportedPeriods = (url) => {
        this.props.fetch({ url })
          .then((data) => {
            if (data.entities.timeplanUnits) {
              const timeplanUnitIds = Object.keys(data.entities.timeplanUnits);
              const workTypesIds = Object.keys(data.entities.workTypes);
              const customersIds = Object.keys(data.entities.customers);
              this.setState({ timeplanUnitIds, workTypesIds, customersIds, isEmpty: false });
            } else {
              this.setState({ isEmpty: true });
            }
          });
      };
      this.setState({ fetchReportedPeriods });
    },
  }),
  branch(({ timeplanUnitIds }) => timeplanUnitIds,
    compose(
      requireProps(['timeplanUnitIds']),
      withTimeplanUnits,
      connect((state, { timeplanUnits }) => ({
        timeplanUnits: timeplanUnits.map((tpu) => {
          const booking = bookingById(state, tpu.get('booking'));
          return tpu.set('customer', booking.customer);
        }),
      })),
      withProps(({ timeplanUnits }) => ({
        timeplanUnits: new List(timeplanUnits),
      })),
      withWorkTypes,
      withProps(({ workTypes }) => ({
        workTypes: new List(workTypes),
      })),
    ),
  ),
)(ReportedTimes);
